/**
 * @fileoverview Loading component.
 */

import { postToHost } from "../../../core/messenger";
import { UI_EVENTS } from "../events";
import type { LoadingSubModule } from "../types";

/**
 * Create the loading sub-module.
 */
export function createLoadingSubModule(): LoadingSubModule {
  return {
    /**
     * Show loading indicator.
     */
    show(): void {
      postToHost(UI_EVENTS.LOADING, { action: "show" });
    },

    /**
     * Hide loading indicator.
     */
    hide(): void {
      postToHost(UI_EVENTS.LOADING, { action: "hide" });
    },
  };
}
